
const KEY_NAME = {
    FUNC: 'fn',
    FUNC_CB: 'cb',
    HYBRID_CB: 'hybridcb',
    HYBRID_CB_GLOBAL_NAME: 'onhybridcb',
    HYBRID_CB_FEATURE_FUNC: 'hybridcbfeaturefunc',
    SRV: 'service',
    MSG: 'msg',
    ERROR: 'error',
    DATA: 'data',
    LAZY_PUSH: 'lazypush',
    ODR_DEL_GAMES: 'odrdeletegames',
    VERSION: 'version',
    LN_SERVER: 'LnServer',
    LN_ORG_ID: 'LnOriginid',
    LN_SESSION_ID: 'LnSessionId',
    JS_LN_SERVER: 'LnServer',
    TIME_OUT: 'timeout',
    TIME_OUT_BEFORE_DISPLAY: 'timeoutbeforedisplay',
    CLOSE_BY_TIME_OUT: 'closebytimeout',
    CLOSE_BY_X: 'closebyx',
    CLOSE_NO_CHILL: 'closenochill',
    CLOSE_BY_LOW_DISK_SPACE: 'closebylowdiskspace',
    FOLDER_STRUCT: 'foldertruct',
    FOLDER_SHARED_NAME: 'sharedFolderName',
    CLOSE_X_POS_P: 'xPosP',
    CLOSE_Y_POS_P: 'yPosP',
    CLOSE_X_POS_L: 'xPosL',
    CLOSE_Y_POS_L: 'yPosL',
    MAIL_TO: 'mailto',
    ID: 'id',
    PORT: 'port',
    KEYBORD: 'keybord',
    ROTATION: 'rotation',
    FORCE: 'force',
    WEB_ID: 'webid',
    TYPE: 'type',
    PROGRESS_BAR_FAKE: 'progressbarfake',
    PROGRESS_BAR_REAL: 'progressbarreal',
    RESOURCE_NAME: 'resourcename',
    X_OF_MENY:  'resourcexofmeny',
    GAME_ID: 'gameid',
    SHARED_FOLDER: 'sharedolder',
    URL: 'url',
    SERVICE: 'service',
    FEATURE_CB: 'featurecb',
    ACTION: 'action',
    OPEN_LINK: 'openlink',
    DEBUG: 'debug',
    RELOAD: 'reload',
    AUTOLOGIN: 'UserInfo',
    SESSIONTIMER: 'sessiontimer',
    HEADER_HEIGHT: 'headerheight',
    BANK_ID: 'bankid',
    PHONE: 'tel:',
    LEFT: 'left',
    RIGHT: 'right',
    TOP: 'top',
    BOTTOM: 'bottom',
    SHOW: 'show',
    DP_TO_PX: 'dp2px',
    LOG_CATEGORY: 'logcategory',
    LOG_ACTION: 'logaction',
    LOG_LABLE: 'loglabel',
    LOG_VALUE: 'logvalue',
    LOG_LEVEL: 'loglevel'
};

const ON_DEMAND = {
    GAME_LOADING_START: 'game_loading_start',
    GAME_LOADING_END: 'game_loading_end',
    GAME_LOADING_CLOSE_BY_X: 'game_loading_close_by_x',
    GAME_LOADING_CLOSE_BY_TIME_OUT: 'game_loading_close_by_time_out',
    GAME_LOADING_CLOSE_BY_LOW_DISK_SPACE: 'game_loading_close_by_low_disk_space',
    GAME_LOADING_CLOSE_BY_NO_CHILL: 'game_loading_close_by_no_chill',
    GAME_LOADING_ERROR: 'game_loading_error',
    CHILL_LOADING_ERROR: 'chill_loading_error',
    CHILL_LOADING: 'chill_loading',
    GAME_LOADING_REAL_ODR_STARTED: 'game_loading_real_odr_started',
    ON_DEMAND_CATEGORY: 'Hybrid_On_Demand',
    ON_DEMAND_DELETE_GAMES: 'odr_delete_games'
};


const LEXIS_NEXIS = {
    SESSION_ID_LOAD_ERROR: 'session_id_load_error',
    SESSION_ID_LOAD_OK: 'session_id_response_success',
    SESSION_ID_REQUEST_SENT: 'session_id_request_sent',
    SESSION_ID_CALL: 'session_id_sent',
    SESSION_ID_LOAD_EMPTY: 'session_id_load_empty',
    SESSION_ID_CLOSE_BY_TIME_OUT: 'close_by_timeout',
    LEXIS_NEXIS_CATEGORY: 'Hybrid_Lexis_Nexis'
};


const ODR_FOLDERS = {
    SHARED_ONE_FOLDER: 1,
    SHARED_MANY_FOLDER: 2,
    SHARED_NONE: 3,
    SHARED_GGP: 4
}

const ODR_SHARED_GAMES = {
    EMPTY : '',
    RED_TIGER : '236redtigershared',
    PRAGMATIC_PLAY : '238pragmaticshared',
    PLAY_N_GO : '237playngoshared',
    PLAY_TECH : '233playtechshared'
}

const ROTATION_KEYS = {
    LANDSCAPE: '-1',
    PORTRATE_UPSIDE_DOWN: '-2',
    PORTRATE: '-3',
    ALL: '-4'
};

const FEATURE_CB_FUNC = {
     HYBRID_WEB_CALL: 'WebViewManagerFeature',
     HYBRID_URL_SCHEME_CALL: 'UrlSchemeFeature',
     HYBRID_PUSH_CALL: 'PushFeature',
     HYBRID_GEO_CALL: 'GeoFeature',
     HYBRID_ON_DEMAND_CALL: 'OnDemandFeature',
     HYBRID_ON_DEMAND_NYX_CALL: 'OnDemandNyxFeature',
     HYBRID_LOBBY_POP_UP_CALL: 'LobbyPopUpFeature',
     HYBRID_FIRE_BASE: 'FireBaseFeature',
     HYBRID_NATIVE_LOGS: 'NativeLogsFeature'
};


const SERIVCES_FUNC_LIST = {


    /* WebView */
    WEB_VIEW_WEB_SHOW: 'WebView_WebShow',
    WEB_VIEW_SAFARI: 'WebView_ShowSafariTest',
    WEB_VIEW_SAFARI_PING: 'WebView_ShowSafariPing',
    WEB_VIEW_ACCOMPLISHED: 'WebView_Accomplished',
    WEB_VIEW_IS_HTML_COMPILED_GAMES: 'WebView_IsHtmlCompiledGames',
    WEB_VIEW_GET_DP_2_PX: 'WebView_GetDpToPx',




    /* General */
    GENERAL_INIT_HYBRID: 'General_InitHybrid',
    GENERAL_ALERT: 'General_Alert',
    GENERAL_ALERT_D: 'General_AlertDebug',
    GENERAL_SET_ROTATION: 'General_SetRotation',
    GENERAL_SET_CB: 'General_SetCallBack',
    GENERAL_OPEN_MAIL: 'General_OpenMail',
    GENERAL_OPEN_EXTERNAL_LINK: 'General_OpenExternalLink',



    /* Serial */
    SERIAL_GET_SERIAL: 'Serial_GetSerial',

    /* 3DTouch */
    T3_D_TOUCH_INIT_SHORTCUTS: 'ThreeDTouch_InitShortcuts',
    T3_D_TOUCH_UPDATE_SHORTCUT: 'ThreeDTouch_UpdateShortcut',
    T3_D_TOUCH_DELETE_SHORTCUT: 'ThreeDTouch_DeleteShortcut',
    T3_D_TOUCH_DEL_ALL_SHORTCUTS: 'ThreeDTouch_DeleteAllShortcuts',
    T3_D_TOUCH_GET_LAUNCH_SHORTCUT: 'ThreeDTouch_GetLaunchShortcut',


    /* TouchID */
    TOUCH_ID_GET_TOKEN: 'TouchID_GetToken',
    TOUCH_ID_OPEN: 'TouchID_Open',
    TOUCH_ID_SET_TOKEN: 'TouchID_SetToken',
    TOUCH_ID_IS_SUPORTED: 'TouchID_IsTouchIdSuported',
    TOUCH_ID_CLEAR_ALL: 'TouchID_ClearAll',
    TOUCH_ID_PARAMS_FOR_TOKEN: 'TouchID_GetParamsForToken',

    /* WebViewManager */
    WEB_SECOND_SET_CB: 'WebView_WebSecondSetCb',
    WEB_SECOND_NAVIFATE: 'WebView_WebSecondNavigate',
    WEB_DEPOSIT_WIDGET_NAVIFATE: 'WebView_WebDepositWidgetNavigate',
    WEB_SECOND_SHOW: 'WebView_WebSecondShow',
    WEB_SECOND_HIDE: 'WebView_WebSecondHide',
    WEB_SECOND_CLOSE: 'WebView_WebSecondClose',
    WEB_SECOND_UPDATE_SIZE: 'WebView_WebSecondUpdateSize',
    WEB_DEPOSIT_WIDGET_SUPPORTED: 'WebView_DepositWidgetSupported',

    /* Info */
    INFO_GET_ALL_INFO: 'Info_GetAllInfo',
    INFO_SET_URL: 'Info_SetUrl',

    /* Url Scheme*/
    URL_SCHEME_SET_CB: 'UrlScheme_SetCb',
    URL_SCHEME_GET_URL_SCHEME: 'UrlScheme_GetUrlScheme',
    URL_SCHEME_CLEAR: 'UrlScheme_Clear',

    /* Fabric */
    FABRIC_ADD_EVENT: 'Fabric_AddEvents',

    /* Push Notifications */
    PUSH_IS_DEVICE_ENABLE: 'PushUA_IsDeviceEnable',
    PUSH_SET_CB: 'PushUA_SetCb',
    PUSH_GET_ACTION: 'PushUA_GetAction',
    PUSH_ADD_TAG: 'PushUA_AddTag',
    PUSH_REM_TAG: 'PushUA_RemTag',
    PUSH_SET_ALIAS: 'PushUA_SetAlias',
    PUSH_PROMPT_PERMISSION: 'PushUA_PromptPermission',

    /*  Geo */
    GEO_SET_CB: 'GeoLocation_SetCb',
    GEO_GET_LOCATION: 'GeoLocation_GetGeoLocation',
    GEO_IS_PERMISSION_SUPPORTED: 'GeoLocation_IsPermissionPopupSupported',
    GEO_SHOW_PERMISSION: 'GeoLocation_ShowGeoPermission',

    /* LEXIS NEXIS*/
    LEXIS_NEXIS_GET_INFO: 'LexisNexis_GetInfo',
    LEXIS_NEXIS_IS_SUPPORTED: 'LexisNexis_IsSupported',

    /*  AppStore Rating Popup */
    RATE_APP: 'StoreRating_RateApp',

    /* On demand */
    ON_DEMAND_IS_READY: 'OnDemand_IsReady',
    ON_DEMAND_CLOSE_GAME: 'OnDemand_CloseGame',
    ON_DEMAND_SET_CB: 'OnDemand_SetCb',
    ON_DEMAND_LOAD_CHILL: 'OnDemand_LoadChill',
    ON_DEMAND_CLOSE_BY_X: 'OnDemand_CloseByX',
    ON_DEMAND_CLOSE_BY_TIME_OUT: 'OnDemand_CloseByTimeOut',
    ON_DEMAND_CLOSE_BY_LOW_DISK_SPACE: 'OnDemand_CloseByLowDiskSpace',
    ON_DEMAND_DELETE_GAME_FOLDER: 'OnDemand_DeleteGameFolder',


    /* On Demand Nyx */
    ON_DEMAND_NYX_SET_CB: 'OnDemandNyx_SetCb',
    ON_DEMAND_NYX_NAVIGATE: 'OnDemandNyx_Navigate',
    ON_DEMAND_NYX_CLOSE: 'OnDemandNyx_Close',
    ON_DEMAND_NYX_CHANGE_HEADER_HEIGHT: 'OnDemandNyx_ChangeHeaderHeight',


    /* Lobby Pop Up */

    LOBBY_POPUP_IS_SUPPORTED: 'LobbyPopUp_IsSupported',
    LOBBY_POPUP_SHOW: 'LobbyPopUp_Show',
    LOBBY_POPUP_CLOSE: 'LobbyPopUp_Close',
    LOBBY_POPUP_SET_CB: 'LobbyPopUp_SetCb',


    /* Fire Base*/
    FIRE_BASE_GET_DATA: 'FireBase_GetData',


    /* Native Logs */

    /* Url Scheme*/
    NATIVE_LOGS_SET_CB: 'NativeLogs_SetCb'
};



const SERIVCES_PARAMS_LIST = {
    WEB_VIEW_SPLASH: 'splash',
    WEB_VIEW_SPLASH_SHOW: '0',
    WEB_VIEW_SPLASH_FADE: '1'
};


const LOCAL_HOST = {
    HTTP: 'http://localhost:8089',
    HTTPS: 'https://localhost:8089'
};

export {KEY_NAME, SERIVCES_FUNC_LIST, SERIVCES_PARAMS_LIST, ROTATION_KEYS, FEATURE_CB_FUNC, ON_DEMAND, ODR_FOLDERS, ODR_SHARED_GAMES, LOCAL_HOST, LEXIS_NEXIS};